(function ($) {
  Drupal.behaviors.pepStartFormatterV1 = {
    attach: function (context, settings) {
      var $pepStartFormatter = $('.js-pep-start-franchise-formatter--v1', context).once();

      $pepStartFormatter.closest('.content').addClass('outer-wrap pep-start-parent-container');

      // removing row class to prevent quickshop content binding in middle of the template
      $(document).on('prodcat.status', function () {
        $pepStartFormatter.find('.row').removeClass('row');
      });
    }
  };
})(jQuery);
